import { render, staticRenderFns } from "./PermisosTable.vue?vue&type=template&id=1aef3df7&scoped=true"
import script from "./PermisosTable.vue?vue&type=script&lang=js"
export * from "./PermisosTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aef3df7",
  null
  
)

export default component.exports